import request from 'api/requestUtils'

interface PublicBundleDate {
  check_in_date: string
  sell_price: number | null
  available: boolean | null
}

interface PublicTourComponent {
  product_type: 'tour'
  sequence_number: number
  is_hero?: boolean
  tour_id: string
}

interface PublicFlashAccommodationComponent {
  product_type: 'flashAccommodation'
  sequence_number: number
  is_hero?: boolean
  offer_id: string
  package_id: string
  nights: number
  occupancy: number
  dates: Array<PublicBundleDate>
}

interface PublicBundle {
  id: string
  name: string
  components: Array<PublicTourComponent | PublicFlashAccommodationComponent>
}

function mapBundleComponent(component: PublicBundle['components'][number]): App.Tours.BundleComponent {
  if (component.product_type === 'tour') {
    return {
      productType: 'tour',
      sequenceNumber: component.sequence_number,
      isHero: component.is_hero ?? false,
      tourId: component.tour_id,
    }
  }

  return {
    productType: 'flashAccommodation',
    sequenceNumber: component.sequence_number,
    isHero: component.is_hero ?? false,
    offerId: component.offer_id,
    packageId: component.package_id,
    nights: component.nights,
    occupancy: component.occupancy,
    dates: component.dates.map(date => ({
      checkInDate: date.check_in_date,
      sellPrice: date.sell_price,
      available: date.available,
    })),
  }
}

export async function getBundle(bundleId: string): Promise<App.Tours.Bundle> {
  const response = await request.get<App.ApiResponse<PublicBundle>>(`/api/bundle/v1/${encodeURIComponent(bundleId)}`)
  // oxlint-disable-next-line no-console
  console.log('Tour bundle JSON:', JSON.stringify(response.result, null, 2))
  return {
    id: response.result.id,
    name: response.result.name,
    components: response.result.components.map(mapBundleComponent),
  }
}
